import CustomMarker from "components/Organisms/map/CustomMarker"
import React, { useMemo } from "react"
import { useParams } from "react-router-dom"
import { useTrip } from "./TripContext"
import useLiveLocation from "./useLiveLocation"

export default function LiveVehicleMarker() {
  const { uuid } = useParams()
  const { location, angle } = useLiveLocation(uuid)
  const { vehicle } = useTrip()
  const imageName = useMemo(() => {
    const type = vehicle?.vehicleType?.category

    // If type is one of these types then straight away assign the name
    if (
      type === "LIGHT_1_2_3" ||
      type === "MEDIUM_4_5_6" ||
      type === "HEAVY_7_8"
    ) {
      return type
    }

    // Else try to co-arce the size based on numbers
    // Usually there is feet in the vehicle category 19-FT, 17-FT, 12-FT etc.
    if (type?.includes("19") || type?.includes("17")) {
      return "HEAVY_7_8"
    } else if (type?.includes("14")) {
      return "MEDIUM_4_5_6"
    } else if (type?.includes("12") || type?.includes("12")) {
      return "LIGHT_1_2_3"
    } else {
      return "LIGHT_1_2_3"
    }
  }, [vehicle])
  return (
    <>
      {location?.lat && location?.lng && (
        <CustomMarker
          className="transition-transform ease-in"
          top="-30px"
          left="-30px"
          position={location}
          style={{
            transform: `rotate(${angle}deg)`,
          }}
        >
          <img
            width="60px"
            height="auto"
            src={`https://cdn.vesatogo.com/images/${imageName}.png`}
            alt={vehicle?.registrationNumber}
          />
        </CustomMarker>
      )}
    </>
  )
}
